var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banners"},[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"banners__list"},_vm._l((_vm.bannersList),function(banner){return _c('li',{staticClass:"banners__item"},[_c('img',{staticClass:"banners__img",attrs:{"src":banner,"alt":"banner"}})])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9232ebc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bannersBlock.vue
// module id = 214
// module chunks = 0